<template>
  <component v-if="erpCamposIntegracao && this.currentComponent && hasFields"
             v-bind:is="currentComponent"
             :form-data="formData"
             :dense="dense"
             ref="camposIntegracao"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentComponent: null,
    };
  },
  computed: {
    ...mapGetters('user', ['erpCamposIntegracao']),
    hasFields() {
      return this.formData && Object.keys(this.formData).length > 0;
    },
  },
  methods: {
    buildComponent() {
      if (!this.erpCamposIntegracao) {
        return;
      }
      const camposErp = this.erpCamposIntegracao.toLowerCase().replace('_', '-');
      this.currentComponent = `px-campos-${this.type}-${camposErp}`;
    },
  },
  watch: {
    erpCamposIntegracao(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.buildComponent();
    },
  },
  mounted() {
    this.buildComponent();
  },
};
</script>
